import { lazy } from 'react';
import { RouteObject } from 'react-router/dist/lib/context';

let Import = (path: string) => lazy(() => import(`./screen/${path}`));

export const routes: RouteObject[] = [
  { path: '/', Component: Import('Home') },
  { path: '/home', Component: Import('Home') },
  { path: '/offerings', Component: Import('Offerings') },
  { path: '/transactions', Component: Import('Transactions') },
  { path: '/contact', Component: Import('Contact') },
  { path: '/agents', Component: Import('Agents') },
  { path: '/portfolio', Component: Import('Portfolio') },
  { path: '/portfolio/:id', Component: Import('Portfolio/PortfolioDetail/PortfolioDetail') },
  { path: '/investor-leads', Component: Import('InvestorLeads') },
  { path: '/llm/prompts', Component: Import('LLM/PromptManager') },
  { path: '/contact/:id', Component: Import('Contact/ContactDetails') },
  { path: '/sign-in', Component: Import('Auth/SignIn') },
  { path: '/sign-up', Component: Import('Auth/SignUp') },
  { path: '/sign-out', Component: Import('Auth/SignOut') },
  { path: '/sign-up-verification', Component: Import('Auth/SignUp/SignUpOTP') },
  { path: '/sign-up-account-type', Component: Import('Auth/SignUp/SignUpAccountType') },
  { path: '/sign-up-complete', Component: Import('Auth/SignUp/SignUpComplete') },
  { path: '/forget-password', Component: Import('Auth/ForgetPassword') },
  { path: '/reset-password', Component: Import('Auth/ResetPassword') },
  { path: '/force-change-password', Component: Import('Auth/ForceChangePassword') },
  { path: '/users', Component: Import('Users') },
  { path: '/users/:id', Component: Import('Users/UserDetail') },
  { path: '/l/*', Component: Import('LegacyPortal') },
  { path: '/project', Component: Import('Project') },
  { path: '/project/:id', Component: Import('Project/ProjectDetail') },
  { path: '/template-engine', Component: Import('TemplateEngine') },
  { path: '/template-engine/:id', Component: Import('TemplateEngine/TemplateEngine') },
  { path: '/user-profile', Component: Import('Auth/UserProfile') },
  { path: '/property/:id', Component: Import('Property/PropertyDetail') },
  { path: '/property/new/:projectId', Component: Import('Property/Property') },
];

export default routes;
